// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__A7dZP","radioRow":"SimpleQuestionBuilderModal_radioRow__3PBTP"};